import { IteratorExpression } from '../Expression.js';
import { SelectExpression } from './SelectExpression.js';
export class OneExpression extends IteratorExpression {
    evaluate(visitor, localVariables) {
        const selectExpression = new SelectExpression(this.getSource());
        selectExpression.setBody(this.getBody());
        selectExpression.setIterators(this.getIterators());
        const result = selectExpression.evaluate(visitor, localVariables);
        return result.length === 1;
    }
}
//# sourceMappingURL=OneExpression.js.map